import React, { useEffect, useRef } from 'react';
import { DatePicker } from 'rsuite';
import { useState } from 'react';
import { isBefore, format, add, sub } from 'date-fns';

const DateChooser = ({ onDataAvailable }) => {

  const [dates, setDates] = useState({
    checkInDate: null,
    checkOutDate: null
  });

  const onDateChange = (inputName, e) => {
    setDates({...dates, [inputName]: e});
  }

  const inputRef = useRef();

  useEffect(() => {
    console.log(dates)
    if (dates.checkInDate && dates.checkOutDate) {
      const checkInString = format(dates.checkInDate, 'yyyy-MM-dd');
      const checkOutString = format(dates.checkOutDate, 'yyyy-MM-dd');
      fetch(`https://dvcrs.herokuapp.com/availability?checkIn=${checkInString}&checkOut=${checkOutString}&occupancy=1`)
        .then(res => res.json())
        .then(result => {
          onDataAvailable(result);
        }
      )
    }
  }, [dates])

  return ( 
    <div>
      <div className="cards">
        <div className="card">
          <p>Check-In Date</p>
          <DatePicker
            oneTap
            block
            ranges={[]}
            disabledDate={date => {
              return isBefore(date, sub(new Date(), {days: 1}))
            }}
            format='M/D/YYYY'
            placeholder="Check-In Date"
            style={{ marginBottom: 8 }}
            onSelect={(value) => { 
              onDateChange('checkInDate', value);
              console.log(inputRef);
              inputRef.current.open()
              inputRef.current.state.pageDate = add(value, {days: 1});
            }}
          />
        </div>

        <div className="card">
          <p>Check-Out Date</p>
          <DatePicker
            ref={inputRef}
            oneTap
            block
            ranges={[]}
            // defaultValue={new Date(dates.checkInDate)}
            disabledDate={date => {
              return isBefore(date, add(dates.checkInDate, {days: 1}) || new Date())
            }}
            format='M/D/YYYY'
            placeholder="Check-Out Date"
            style={{ marginBottom: 8 }}
            onSelect={(value) => { onDateChange('checkOutDate', value) }}
          />
        </div>
      </div>

    </div>
  )}

  export default DateChooser;